import { useMemo } from "react";
import { useAuth } from "./useAuth";
import { PERMISSIONS_BY_ROLE, ROLES, type Permission, type Role } from "../constants/permissions";

type ExternalRole = { RoleId: string; RoleName: string };

const isRoleName = (value: string): value is Role => (Object.values(ROLES) as string[]).includes(value);

const toRoleNames = (items: Array<string | ExternalRole> | undefined | null): Role[] => {
    if (!Array.isArray(items)) return [];
    const names = items.map((item) => (typeof item === "string" ? item : item?.RoleName));
    return names.filter((n): n is Role => Boolean(n) && isRoleName(n));
};

export function useAuthorization() {
    const { roles } = useAuth();

    const normalizedRoles: Role[] = useMemo(() => toRoleNames(roles as any), [roles]);

    const can = (permission: Permission): boolean => {
        if (!normalizedRoles.length) return false;
        return normalizedRoles.some((role) => PERMISSIONS_BY_ROLE[role]?.has(permission));
    };

    const hasRole = (role: Role): boolean => normalizedRoles.includes(role);

    return { can, hasRole, roles: normalizedRoles };
}
